import React from 'react';
import { cn } from '../../utils/cn';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  className,
}) => {
  const center = align === 'center';

  return (
    <div className={cn(center ? 'mx-auto text-center' : 'text-left', className)}>
      {eyebrow && (
        <span className="section-eyebrow">
          {eyebrow}
        </span>
      )}
      <h2 className={cn('section-title', center && 'mx-auto')}>
        {title}
      </h2>
      {subtitle && (
        <p className={cn('section-subtitle', center && 'mx-auto')}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
